const CarouselPlanItem = ({ children, key }) => {
  return (
    <div key={key} className="carousel-plan-item-container">
      {children}
    </div>
  );
};

export default CarouselPlanItem;
